import React from 'react';
import { Breadcrumb, Layout, notification, Modal, Select } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getTraspasosPorOrganismo from '../../../graphql/querys/rrhh/getTraspasosPorOrganismo.graphql';
import TablaTraspasos from '../traspasos/TablaTraspasos';
import deleteTraspaso from '../../../graphql/mutations/rrhh/deleteTraspaso.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
const confirm = Modal.confirm;

@compose(
  graphql(getUsuario, {
    name: 'usuario',
  }),
  graphql(deleteTraspaso, {
    name: 'deleteTraspaso',
    // options: {
    //   refetchQueries: [{ query: getTraspasos }]
    // }
  }),
  graphql(getOrganismos)
)
class TraspasosPorOrganismo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      primeraCarga: true,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.usuario && !this.state.llamada) {
      this.cambiarOrganismo(nextProps.usuario.getUsuario.organismo._id);
    }
  }

  cambiarOrganismo = idOrganismo => {
    this.setState(
      {
        ...this.state,
        idOrganismo: idOrganismo,
        loading: true,
      },
      () => {
        this.props.client
          .query({
            query: getTraspasosPorOrganismo,
            variables: { idOrganismo: idOrganismo },
            fetchPolicy: 'network-only',
          })
          .then(res => {
            const traspasos = res.data.getTraspasosPorOrganismo;
            // console.log("Respuesta exitosa!");
            // console.log(traspasos);
            // console.log(idOrganismo);

            this.setState(
              {
                ...this.state,
                llamada: true,
                listaTotal: traspasos,
                loading: false,
              },
              function() {
                this.ordenarLista(1, 10);
              }
            );
          })
          .catch(err => {
            console.log('Error en la busqueda de traspasos');
            console.log(err);

            this.setState({ loading: false });

            Modal.error({
              title:
                'Error a la hora de buscar los traspasos en la base de datos',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      }
    );
  };

  obtenerNombreOrganismo = idOrganismo => {
    let nombre = '';
    let organismo = _.find(this.props.data.getOrganismos, { _id: idOrganismo });
    organismo ? (nombre = organismo.nombre) : (nombre = '');
    return nombre;
  };

  _executeSearch = async () => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loading: true,
    });

    let listaFiltrada = _.filter(this.props.data.getTraspasos, traspaso => {
      return (
        traspaso.usuarioSaliente.nombre
          .toUpperCase()
          .indexOf(this.state.filtro.toUpperCase()) > -1 ||
        traspaso.usuarioSaliente.apellido
          .toUpperCase()
          .indexOf(this.state.filtro.toUpperCase()) > -1 ||
        traspaso.usuarioSaliente.username
          .toUpperCase()
          .indexOf(this.state.filtro.toUpperCase()) > -1
      );
    });

    this.setState(
      {
        ...this.state,
        loading: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  // eslint-disable-next-line no-unused-vars
  filtrarPorNombre = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loading: true,
    });

    let listaFiltrada = _.filter(this.props.data.getTraspasos, traspaso => {
      return (
        traspaso.usuarioSaliente.nombre
          .toUpperCase()
          .indexOf(this.state.filtro.toUpperCase()) > -1 ||
        traspaso.usuarioSaliente.apellido
          .toUpperCase()
          .indexOf(this.state.filtro.toUpperCase()) > -1 ||
        traspaso.usuarioSaliente.username
          .toUpperCase()
          .indexOf(this.state.filtro.toUpperCase()) > -1
      );
    });

    this.setState(
      {
        ...this.state,
        loading: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  ordenarLista = (numPagina, tamPagina) => {
    let listaOrdenada = _.orderBy(
      this.state.listaTotal,
      [
        traspaso => {
          return traspaso.usuarioSaliente.nombre.toUpperCase();
        },
      ],
      ['asc']
    );

    let listaCorta = _.slice(
      listaOrdenada,
      0 + (numPagina - 1) * tamPagina,
      tamPagina * numPagina
    );

    this.setState({
      ...this.state,
      currentPage: numPagina,
      lista: listaCorta,
    });
  };

  onDelete = id => {
    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar este traspaso?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteTraspaso({
            variables: { _id: id },
          })
          .then(res => {
            // console.log("La respuesta del delete fue....");
            // console.log(res);

            let id = res.data.deleteTraspaso;

            if (id) {
              notification.warning({
                message: 'Traspaso eliminado',
                description: 'Se ha eliminado el traspaso exitosamente',
              });
            }
          })
          .catch(err => {
            console.log('Existio un error a la hora de eliminar el traspaso');
            console.log(err);

            Modal.error({
              title: 'Error en la eliminacion el traspaso ',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  render() {
    if (this.state.loading || this.props.data.loading) {
      return <Loading />;
    }

    let usuario = this.props.usuario;
    let fGeneracion = moment(new Date()).format('DD/MM/YYYY HH:mm');

    const pagination = {
      pageSize: 10,
      current: this.state.currentPage,
      total: this.state.listaTotal ? this.state.listaTotal.length : 0,
      onChange: (page, pageSize) => {
        this.ordenarLista(page, pageSize);
      },
    };

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Gestion Humana</Breadcrumb.Item>
          <Breadcrumb.Item>Traspasos</Breadcrumb.Item>
          <Breadcrumb.Item>Consultar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <div>
            <h1 style={{ textAlign: 'center', marginTop: 15 }}>
              Administración General
            </h1>
            <h2 style={{ textAlign: 'center', marginTop: 40 }}>TRASPASOS</h2>
            <h3 style={{ textAlign: 'center', marginTop: 20 }}>
              ORGANISMO:
              <Select
                style={{ width: 500, marginLeft: 10 }}
                id="organismos"
                placeholder="Seleccione el organismo"
                defaultValue={usuario.getUsuario.organismo._id}
                disabled={
                  usuario.getUsuario.rol != 'GESTION HUMANA' &&
                  usuario.getUsuario.rol != 'SUPERVISOR'
                }
                onSelect={valor => this.cambiarOrganismo(valor)}
              >
                {this.props.data.getOrganismos &&
                  this.props.data.getOrganismos.map(organismo => (
                    <Select.Option key={organismo._id}>
                      {organismo.nombre}
                    </Select.Option>
                  ))}
              </Select>
            </h3>

            <h5 style={{ textAlign: 'center', marginTop: 20 }}>
              FECHA DE GENERACION: {fGeneracion}
            </h5>

            <TablaTraspasos
              traspasos={this.state.lista}
              usuario={this.props.usuario}
              history={this.props.history}
              onDelete={this.onDelete}
              pagination={pagination}
              filtrarPorNombre={this.filtrarPorNombre}
              loading={this.state.loading}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(TraspasosPorOrganismo);
